import React, { Component } from "react";
import "./Site.css";
import {
  Card,
  CardFooter,
  Row,
  Col,
  Button,
  Input,
  Label,
  CardDeck,
  Badge
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api } from "../helpers";
import Alert from "react-s-alert";
import { Link } from "react-router-dom";
import { LineGraph } from "../components";
import classnames from "classnames";
//import _ from "lodash";

export default class ProductionDemandDetails extends Component {
  static displayName = ProductionDemandDetails.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      productData: props.productData
    };
  }

  onSave(fromOverride) {
    let product = Object.assign({}, this.state.productData);
    let payload = {
      Id: product.Id,
      ProductId: product.productId,
      PriorDayInventoryTotal: fromOverride
        ? parseInt(product.currentCycleCountTotal, 10)
        : parseInt(product.priorDayInventoryTotal, 10),
      PriorDayWorkInProgress: parseInt(product.priorDayWorkInProgress, 10),
      DemandReportDate: product.demandReportDate,
      IsCycleCountUpdate: fromOverride ? true : false
    };
    api
      .post("Product/SaveProductionInventoryAndWIP", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${product.productName}'s totals has been updated.`);
          product.editing = false;
          this.setState({
            productData: product
          });
          this.props.refresh();
        } else {
          Alert.error(
            `An error occurred. ${
              product.productName
            }'s production data cannot be updated at this time.`
          );
        }
      })
      .catch(error =>
        Alert.error(
          `There was an error updating ${
            product.productName
          }'s production data.`
        )
      );
  }

  overrideInventoryCount() {
    let product = Object.assign({}, this.state.productData);
    if (
      !window.confirm(
        `Are you sure you want to override the inventory count of ${
          product.priorDayInventoryTotal
        } to the current cycle count of ${product.currentCycleCountTotal}?`
      )
    )
      return;
    this.onSave(true);
  }

  onEdit() {
    let product = Object.assign({}, this.state.productData);

    product.editing = true;
    this.setState({
      productData: product
    });
  }

  onInputChange(e) {
    this.setState({
      productData: {
        ...this.state.productData,
        [e.target.name]: e.target.value
      }
    });
  }

  render() {
    const productData = this.state.productData;
    return (
      <div key={productData.productId}>
        <CardDeck className="mt-2">
          <Card className="p-2">
            <Row>
              <Col>
                <Label className="productTitle">
                  Name: {productData.productName} SKU: {productData.productSku}
                </Label>
                <LineGraph
                  data={productData.shippingCountList}
                  xAxisLabels={productData.dateList}
                  label="Sales Count"
                  borderColor="#3399cc"
                  hoverBorderColor="3399cc"
                />
                <LineGraph
                  data={[
                    productData.productionCountList,
                    productData.inventoryCountList
                  ]}
                  xAxisLabels={productData.dateList}
                  label={["Production Count", "Inventory Count"]}
                  borderColor={["#ff9999", "#FF0000"]} //4ABCAC
                  hoverBorderColor={["ff9999", "#FF0000"]}
                  isMultiLine={true}
                />
              </Col>
            </Row>
          </Card>

          <Card className="p-2">
            {productData.missingInitialInventoryCount && (
              <Row>
                <Col>
                  <Badge color="warning">
                    Product is missing initial inventory count to perform
                    automated calculations
                  </Badge>
                </Col>
              </Row>
            )}
            <Row className="mb-2">
              <Col>
                <Link
                  to={`/product_inventory_changelog/${productData.productId}`}
                >
                  Prior Day Inventory
                </Link>
                <Input
                  name="priorDayInventoryTotal"
                  value={productData.priorDayInventoryTotal}
                  onChange={e => this.onInputChange(e)}
                  type="number"
                  id="priorDayInventoryTotal"
                />
              </Col>
              <Col>
                <Label>
                  <Link to={`/production_summary`}>
                    Prior Day Production Count
                  </Link>
                </Label>
                <Input
                  name="productionCount"
                  value={productData.priorDayProductionCount}
                  disabled
                />
              </Col>
              <Col>
                <Label>
                  <Link to={`/production_summary`}>
                    Prior Day Shipping Count
                  </Link>
                </Label>
                <Input
                  name="priorShippingCount"
                  value={productData.priorDaySaleCount}
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-2">
              <Col>
                <Label>Prior Day Work In Progress</Label>
                <Input
                  name="priorDayWorkInProgress"
                  value={productData.priorDayWorkInProgress}
                  onChange={e => this.onInputChange(e)}
                  type="number"
                  id="priorDayWorkInProgress"
                />
              </Col>
              <Col>
                <Label>Work In Progress Shipped</Label>
                <Input
                  name="workInProgressShipped"
                  value={productData.workInProgressShipped}
                  disabled
                />
              </Col>
              <Col>
                <Label>Real-Time WIP</Label>
                <Input
                  name="realTimeWorkInProgress"
                  value={productData.realTimeWorkInProgress}
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-2">
              <Col>
                <Label>Inventory + WIP</Label>
                <Input
                  name="InventoryAndWip"
                  value={productData.inventoryPlusWip}
                  disabled
                />
              </Col>
              <Col>
                <Label>Percent Supply Level</Label>
                <Input
                  name="percentSupplyLevel"
                  value={productData.displaySupplyLevel}
                  disabled
                  className={classnames(
                    {
                      badSupplyLevel: productData.isInventoryLow ? true : false
                    },
                    {
                      goodSupplyLevel: !productData.isInventoryLow
                        ? true
                        : false
                    }
                  )}
                />
              </Col>
              <Col>
                <Label>{productData.preferredDemandDays} Day Demand</Label>
                <Input
                  name="preferredDemandDays"
                  value={productData.onHandDemand}
                  disabled
                />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <Label>Days On Hand</Label>
                <Input
                  name="daysOnHand"
                  value={productData.daysOnHand}
                  disabled
                />
              </Col>
              <Col>
                <Label>Current Cycle Count Total</Label>
                <Input
                  name="cycleCount"
                  value={productData.currentCycleCountTotal}
                  disabled
                />
              </Col>
              <Col />
            </Row>
            <CardFooter>
              <Button
                className="cbdmdPrimaryOutline boldText float-left"
                onClick={() => this.overrideInventoryCount()}
              >
                <div>
                  <span>Override Inventory Count</span>
                </div>
                <span className="mr-2">Current Cycle Count: </span>
                <span>{productData.currentCycleCountTotal}</span>
              </Button>
              <Button
                size="sm"
                color="primary"
                className="float-right"
                onClick={() => this.onSave()}
                title="Save changes"
              >
                <FontAwesomeIcon icon="save" />
              </Button>
            </CardFooter>
          </Card>
        </CardDeck>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductionDemandDetails.js